import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer animate-fade-up"
      title={`${movie.title} 高清在线观看`}
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} 在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/20 to-transparent opacity-70 group-hover:opacity-95 transition-opacity duration-300"></div>

        <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-xs font-label bg-accent-500 text-background-50">
          {movie.type === "movie" ? "电影" : "剧集"}
        </span>

        <span className="absolute top-2 right-2 px-2 py-0.5 rounded text-xs font-label bg-background-50/80 text-accent-400 backdrop-blur">
          {movie.rating.toFixed(1)}
        </span>

        {typeof rank === "number" && (
          <span className="absolute bottom-2 left-2 font-heading text-3xl font-extrabold text-foreground-950/90 leading-none">
            {rank < 10 ? `0${rank}` : rank}
          </span>
        )}

        <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-12 h-12 rounded-full bg-primary-500 text-foreground-950 flex items-center justify-center">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </span>
      </div>

      <div className="mt-3">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 clamp-2 group-hover:text-accent-400 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">
          {movie.year} · {movie.region} · {movie.duration}
        </p>
        <p className="mt-1 text-xs text-foreground-600 clamp-2">
          {movie.actors.join(" / ")}
        </p>
      </div>
    </Link>
  );
}